import moment, { Moment } from "moment-timezone";
import React, { Component } from "react";
import IErrorDTO from "../../../../models/DTO/IErrorDTO";
import IGetHolidaysDTO from "../../../../models/DTO/IGetHolidaysDTO";
import IOnGetHolidaysDTO from "../../../../models/DTO/IOnGetHolidaysDTO";
import IOnProcessHolidaysDTO from "../../../../models/DTO/IOnProcessHolidaysDTO";
import IProcessHolidaysDTO from "../../../../models/DTO/IProcessHolidaysDTO";
import EndpointsEnum from "../../../../models/EndpointsEnum";
import IHolidayUI from "../../../../models/IHolidayUI";
import INewHoliday from "../../../../models/INewHoliday";
import INotification from "../../../../models/INotification";
import IOwTableCols from "../../../../models/IOwTableCols";
import ISupplierModel from "../../../../models/ISupplierModel";
import IUserUI from "../../../../models/IUserUI";
import NotificationLevelEnum from "../../../../models/NotificationLevelEnum";
import NotificationPositionEnum from "../../../../models/NotificationPositionEnum";
import OwButton from "../../../shared/OwButton/OwButton";
import OwDateInput from "../../../shared/OwDateInput/OwDateInput";
import OwInputWrapper from "../../../shared/OwInputWrapper/OwInputWrapper";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import OwTable from "../../../shared/OwTable/OwTable";
import OwTitle from "../../../shared/OwTitle/OwTitle";
import "./HolidaysSidebar.scss";
import { Socket } from "socket.io-client";
import {ConfirmDeleteOverlayFn} from "../../../shared/ConfirmDeleteOverlayFn/ConfirmDeleteOverlayFn";
import {OwDeleteEditActions} from "../../../shared/OwDeleteEditActions/OwDeleteEditActions";
import {OwAcceptCancelActions} from "../../../shared/OwAcceptCancelActions/OwAcceptCancelActions";

type Props = {
    cancelFn: () => void;
    socket: Socket;
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
};

type State = {
    holidays: IHolidayUI[];
    hasChanges: boolean;
    confirmDeleteRow: null | IHolidayUI;
    sourceElement: string | null;
    newHoliday: INewHoliday;
    hasNewHoliday: boolean;
    columns: IOwTableCols[];
    isDataFetching: boolean;
    isInitialData: boolean;
};

class HolidaysSidebar extends Component<Props, State> {
    constructor(props: any) {
        super(props);

        this.state = {
            holidays: [],
            hasChanges: false,
            confirmDeleteRow: null,
            sourceElement: null,
            newHoliday: {} as INewHoliday,
            hasNewHoliday: false,
            columns: [
                {
                    title: "",
                    valueProp: "",
                    renderFn: this.renderActionsFn,
                    renderFnEmitsRow: true,
                    isActionsCol: true,
                },
                {
                    title: "name",
                    valueProp: "name",
                    renderFn: this.renderNameFn,
                    renderFnEmitsRow: true,
                },
                {
                    title: "date",
                    valueProp: "date",
                    renderFn: this.renderDateFn,
                    renderFnEmitsRow: true,
                },
            ],
            isDataFetching: false,
            isInitialData: true,
        };
    }

    componentDidMount() {
        this.props.socket.on(EndpointsEnum.SuppliersOnGetHolidays, this.onGetHolidays);
        this.props.socket.on(EndpointsEnum.SuppliersOnProcessHolidays, this.onProcessHolidays);

        this.getHolidays();
    }

    componentWillUnmount() {
        this.props.socket.removeListener(EndpointsEnum.SuppliersOnGetHolidays, this.onGetHolidays);
        this.props.socket.removeListener(EndpointsEnum.SuppliersOnProcessHolidays, this.onProcessHolidays);
    }

    renderActionsFn = (row: IHolidayUI, index: number) => {
        return (
            <div>
                <OwDeleteEditActions isEditMode={row.editMode} onTrashClickFn={() => {
                    this.confirmDelete(row, index);
                }} onEditClickFn={() => {
                    this.toggleEditMode(row);
                }}/>
                <OwAcceptCancelActions isEditMode={!row.editMode} onAcceptClickFn={() => {
                    this.toggleEditMode(row);
                }} onCancelClickFn={() => {
                    this.toggleEditMode(row);
                }}/>
            </div>
        );
    };

    renderNameFn = (row: IHolidayUI) => {
        return (
            <div>
                {!row.editMode ? (
                    <div className={row.deleteFlag? "text-strikethrough" : ""}>{row.name}</div>
                ) : (
                    <OwInputWrapper
                        name={"name"}
                        fn={(e: any) => {
                            this.handleChange(e, row);
                        }}
                        value={row.name}
                    />
                )}
            </div>
        );
    };

    renderDateFn = (row: IHolidayUI) => {
        return (
            <div>
                {!row.editMode ? (
                    <div>{row.start}</div>
                ) : (
                    <div className={"w-13r"}>
                        <OwDateInput
                            fn={(e: any) => {
                                this.handleDateChange(e, row);
                            }}
                            selectedDate={row.dateInputMoment}
                            popperPlacement="bottom-end"
                        />
                    </div>

                )}
            </div>
        );
    };

    getHolidays = () => {
        const payload: IGetHolidaysDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.SuppliersGetHolidays, payload);

        this.setState({
            isDataFetching: true,
        });
    };

    onGetHolidays = (data: IOnGetHolidaysDTO) => {
        const holidays = data.holidays.map((holiday) => {
            const uiHoliday: IHolidayUI = {
                ...holiday,
                editMode: false,
                dateInputMoment: moment(holiday.start),
            };

            return uiHoliday;
        });

        this.setState({
            holidays,
            isInitialData: false,
            isDataFetching: false,
        });
    };

    toggleEditMode = (row: IHolidayUI) => {
        const holidays = this.state.holidays;

        for (const holiday of holidays) {
            if (holiday.id === row.id) {
                holiday.editMode = !holiday.editMode;
            }
        }

        this.setState({
            holidays,
        });
    };

    handleChange = (e: any, row: IHolidayUI) => {
        const value = e.target.value;
        const name = e.target.name;

        const holidays = this.state.holidays;

        for (const holiday of holidays) {
            if (holiday.id === row.id) {
                // @ts-expect-error
                holiday[name] = value;
            }
        }

        this.setState({
            holidays,
            hasChanges: true,
        });
    };

    handleDateChange = (e: Moment, row: IHolidayUI) => {
        const value = e;

        const holidays = this.state.holidays;

        for (const holiday of holidays) {
            if (holiday.id === row.id) {
                holiday.dateInputMoment = value;
            }
        }

        this.setState({
            holidays,
            hasChanges: true,
        });
    };

    confirmDelete = (row: IHolidayUI, index: number) => {
        const sourceElement = `holiday-row-${index}`;

        this.setState({
            confirmDeleteRow: row,
            sourceElement,
        });
    };

    cancelDelete = () => {
        this.setState({
            confirmDeleteRow: null,
            sourceElement: null,
        });
    };

    commitDelete = () => {
        const holidays = this.state.holidays;

        for (const holiday of holidays) {
            if (holiday.id === this.state.confirmDeleteRow?.id) {
                holiday.deleteFlag = !holiday.deleteFlag;
            }
        }

        this.setState({
            holidays,
            hasChanges: true,
            sourceElement: null,
        });
    };

    save = () => {
        const holidays = this.state.holidays;

        for (const holiday of holidays) {
            if (holiday.dateInputMoment) {
                holiday.start = holiday.dateInputMoment.format("YYYY-MM-DD");
            }
        }

        const payload: IProcessHolidaysDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            holidays,
        };

        this.props.socket.emit(EndpointsEnum.SuppliersProcessHolidays, payload);
    };

    onProcessHolidays = (data: IOnProcessHolidaysDTO) => {
        const notification: INotification = {
            message: "successfully_processed_holidays",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        this.props.notifyFn(null, notification);

        this.setState(
            {
                newHoliday: {
                    name: "",
                    start: ""
                } as INewHoliday,
                hasChanges: false,
            },
            () => {
                this.getHolidays();
            }
        );
    };

    newHolidayChange = (e: any) => {
        const name = e.target.name;
        const value = e.target.value;

        const newHoliday = this.state.newHoliday;

        // @ts-expect-error
        newHoliday[name] = value;

        this.setState({
            newHoliday,
        });
    };

    newHolidayDateChange = (date: Moment) => {
        const newHoliday = this.state.newHoliday;

        // @ts-expect-error
        newHoliday.start = date;

        this.setState({
            newHoliday,
            hasNewHoliday: true,
        });
    };

    addHoliday = () => {
        const payload: IProcessHolidaysDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            holidays: [this.state.newHoliday],
        };

        this.props.socket.emit(EndpointsEnum.SuppliersProcessHolidays, payload);
    };

    render() {
        return (
            <div className="HolidaysSidebar p-2 position-relative">
                <div className={"col-12"}>
                    <div className="text-end">
                        <button className="btn btn-danger btn-sm" onClick={this.props.cancelFn}>
                            <i className="far fa-times" />
                        </button>
                    </div>
                    <OwTitle className={"mb-2"} leftIconName={"fad fa-tree-palm"} title={"holidays"} />
                    <hr />
                </div>

                <div className={"mb-3"}>
                    <OwLabel title={"create_holiday"} />
                    <div>
                        <div className={"mb-2"}>
                            <OwLabel title={"name"} noBottomMargin={true} />
                            <OwInputWrapper name={"name"} fn={this.newHolidayChange} value={this.state.newHoliday.name} />
                        </div>

                        <div className={"mb-2"}>
                            <OwLabel title={"date"} noBottomMargin={true} />
                            <OwDateInput selectedDate={this.state.newHoliday.start} fn={this.newHolidayDateChange} />
                        </div>

                        <div>
                            <OwButton
                                title={"add"}
                                leftIconClass={"fas fa-plus"}
                                fn={this.addHoliday}
                                disabled={!this.state.hasNewHoliday}
                                disableOnActive={true}
                            />
                        </div>
                    </div>
                </div>

                <div className={"mb-2 position-relative"} >
                    <ConfirmDeleteOverlayFn
                        targetElem={this.state.sourceElement}
                        handleConfirm={this.commitDelete}
                        handleCancel={this.cancelDelete}
                        skipMainView={true}
                        nestedParentElem={"holiday-table"}
                    />

                    <OwTable
                        id={"holiday-table"}
                        columns={this.state.columns}
                        dataSet={this.state.holidays}
                        userModel={this.props.userModel}
                        supplierModel={this.props.supplierModel}
                        dataFetch={this.state.isDataFetching}
                        initialData={this.state.isInitialData}
                        tableConfig={{ tableStriped: true }}
                        rowIdName={`holiday-row`}
                    />
                </div>

                <div className={"d-flex"}>
                    <div>
                        <OwButton title={"save"} fn={this.save} disabled={!this.state.hasChanges} disableOnActive={true} />
                    </div>
                    {this.state.hasChanges ? (
                        <OwLabel className={"text-warning"} leftIconClass={"fa fa-exclimation-triangle"} title={"pending_changes"} />
                    ) : null}
                </div>
            </div>
        );
    }
}

export default HolidaysSidebar;
